import {
    MTJ__SINGLE_END_A,
    MTJ__SINGLE_END_B,
    MTJ__SINGLE_END_A_THEN_END_B,
    MTJ__DOUBLE
} from '@shared/constants/constants';
import { Assembly, MTJConfigurations } from '@shared/types/test-plan/types';

type TestSelections = Pick<
    Assembly,
    'insertionLossSideA' | 'insertionLossSideB' | 'insertionLossTotal' | 'returnLossSideA' | 'returnLossSideB'
>;

/**
 * Returns the MTJ configuration implied by the current insertion-/return-loss test selections.
 *
 * Call this whenever a test-type selection changes so the configuration stays consistent with the
 * selected tests. It only computes the *default* — an explicit choice made via the MTJ tiles (e.g.
 * Dual MTJ for return-loss on both ends with no insertion loss) is set directly and persists until
 * the next test-type change re-derives it.
 *
 * Deriving on every test-type change is what keeps Dual MTJ from sticking when it becomes invalid:
 * adding insertion loss on top of return-loss-on-both-ends re-derives to single MTJ (both ends),
 * even though the OR-combined "side A / side B has a test" flags did not change.
 */
export function deriveMtjConfiguration(assembly: TestSelections): MTJConfigurations {
    if (assembly.insertionLossTotal) {
        return MTJ__DOUBLE;
    }

    const sideA = assembly.insertionLossSideA || assembly.returnLossSideA;
    const sideB = assembly.insertionLossSideB || assembly.returnLossSideB;

    if (sideA && sideB) {
        return MTJ__SINGLE_END_A_THEN_END_B;
    }
    if (sideB) {
        return MTJ__SINGLE_END_B;
    }
    return MTJ__SINGLE_END_A;
}
